import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "./Reveal";

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.22em] text-amber ${className}`}
  >
    <span className="h-px w-6 bg-amber/60" />
    {children}
  </span>
);

export const PrimaryLink = ({ to, children, testid, className = "" }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full bg-amber px-6 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:bg-amber-soft hover:gap-3 ${className}`}
  >
    {children}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
  </Link>
);

export const GhostLink = ({ to, children, testid, className = "" }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:border-amber/60 hover:bg-white/5 ${className}`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const PageHero = ({ overline, titleLines, subtitle, image }) => (
  <section className="relative pt-40 pb-20 lg:pt-52 lg:pb-28 overflow-hidden" data-testid="page-hero">
    <div className="absolute inset-0 z-0 overflow-hidden">
      {image && (
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover opacity-45"
        />
      )}
      <div className="absolute inset-0 bg-ink/45" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-b from-transparent to-ink" />
      <div className="absolute -top-40 right-0 h-[36rem] w-[36rem] rounded-full bg-amber/10 blur-[120px]" />
    </div>
    <div className="container-x relative z-10">
      <Reveal>
        <Overline>{overline}</Overline>
      </Reveal>
      <h1 className="mt-6 font-display font-extrabold tracking-tight leading-[0.95] text-4xl sm:text-6xl lg:text-7xl text-white">
        <MaskedLines lines={titleLines} delay={0.1} />
      </h1>
      {subtitle && (
        <Reveal delay={0.4}>
          <p className="mt-7 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-300">
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

export const StatBlock = ({ value, label, testid }) => (
  <div data-testid={testid} className="card-surface rounded-2xl p-6 lg:p-8">
    <div className="font-display font-extrabold text-4xl lg:text-5xl text-gradient-amber">{value}</div>
    <div className="mt-2 text-sm text-slate-400">{label}</div>
  </div>
);
